import { StyledPremiumBanner } from './styled';

const PremiumBanner = () => (
  <StyledPremiumBanner>
    <h1 className="cta-heading">Get in touch!</h1>
    <div className="lead">Send us any questions, feedback or suggestions you might have</div>
  </StyledPremiumBanner>
);

export default PremiumBanner;
